module.exports = __webpack_public_path__ + "static/media/atman fish banner.0030eaab.png";